import { CommonService } from './../common/common.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(
    private _httpClient: HttpClient,
    private _commonService: CommonService
  ) {
  }

  /**
    * getMenuItems
    */
  public getMenuItems(endPoint: string = 'user/menu') {
    const apiUrl = this._commonService.getApiUrl();
    return this._httpClient.get(`${apiUrl}/${endPoint}`);
  }
}
